export enum UIMutationTypes {
  RESET_MOBILE_NAV = 'RESET_MOBILE_NAV',
  TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV',
  SET_OPENED_MODAL = 'SET_OPENED_MODAL',
  RESET_OPENED_MODAL = 'RESET_OPENED_MODAL',
  TOGGLE_DESKTOP_NAV = 'TOGGLE_DESKTOP_NAV',
  RESET_DESKTOP_NAV = 'RESET_DESKTOP_NAV',
}
